import React, { useEffect, useState } from "react";
import "./About.css";
import API from "../api/Api";

const AboutCsrPortal = () => {
  const [csrPortal, setCsrPortal] = useState([]);

  useEffect(() => {
    const fetchCsrPortal = async () => {
      try {
        const res = await API.get("/about_csr_portal");

        if (res.data?.data?.length) {
          setCsrPortal(res.data.data);
        }

        console.log("CSR Portal Data:", res.data.data);
      } catch (error) {
        console.error("Error fetching CSR portal data:", error);
      }
    };

    fetchCsrPortal();
  }, []);

  return (
    <section className="about-csr-section">
      <div className="container">

        {/* Header */}
        <div className="about-csr-header">
          <span className="about-csr-badge">OUR PURPOSE</span>
          <h2 className="about-csr-title">About the CSR Portal</h2>
        </div>

        {/* Content Cards */}
        <div className="about-csr-cards">
          {csrPortal.length > 0 ? (
            csrPortal.map((item) => (
              <div className="about-csr-card" key={item.csr_portal_id}>
                <h4 className="about-csr-card-title">
                  {item.title}
                </h4>

                <p className="about-csr-text">
                  {item.description}
                </p>

               
              </div>
            ))
          ) : (
            <p>Loading content...</p>
          )}
        </div>

      </div>
    </section>
  );
};

export default AboutCsrPortal;
